import { useRouteError } from "react-router-dom";

export default function ErrorPage() {
  const error = useRouteError();

  return (
    <div className="m-5">
      <div className="card">
        <div className="card-body">
          <h1>An error occurred</h1>
          <p>{error.statusText || error.message}</p>
        </div>
      </div>
    </div>
  );
}
